import { WorkflowActionTypes } from 'src/app/models/RestApiCaller/Enums/workflow-action-types';
import { BaseActionData } from './base-action-data';

/**
 * Représente les données de l'action 'Appel d'API'.
 */
export class CallApiActionData extends BaseActionData {
    /**
     * Id de la configuration d'API à utiliser pour appeler l'API.
     */
    public configurationApiId: string;

    /**
     * Constructeur.
     */
    constructor() {
        super(WorkflowActionTypes.ApiCall);
    }

    /**
     * Retourne une copie d'une instance de ActivateStepActionData
     * @param other : Instance source.
     * @returns : Copie de l'instance.
     */
    public static clone(other: CallApiActionData) {
        if (!!other) {
            const instance = new CallApiActionData();
            instance.configurationApiId = other.configurationApiId;
            instance.type = other.type;

            return instance;
        } else {
            return null;
        }
    }
}
